import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSettingsContext } from '../../context/settings';
import { useAuthContext } from 'src/context/auth';
import { getClientModules } from 'src/clients/client-config';

interface ProtectedRouteProps {
  children: React.ReactElement;
  requiresBannerCreation?: boolean;
  requiresModule?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiresBannerCreation = false,
  requiresModule
}) => {
  const { settings } = useSettingsContext();
  const { userInfo } = useAuthContext();

  if (requiresBannerCreation && settings.disableBannerCreation) {
    return <Navigate to='/' replace />;
  }

  if (requiresModule) {
    const clientId = userInfo?.['custom:clientId'];
    if (!getClientModules(clientId).includes(requiresModule)) {
      return <Navigate to='/' replace />;
    }
  }

  return children;
};
